import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class EdSectionFolderIcon extends Vue {

  @Prop() readonly opened: boolean;
  @Prop() readonly folderIconName: string;
  @Prop() readonly folderIconOpenName: string;
  @Prop() readonly selected: boolean;

  get folderIcon() {
    return this.folderIconName || 'folder';
  }

  get folderOpenIcon() {
    return this.folderIconOpenName || 'folder-open';
  }

  get icon(): string {
    return this.opened ? this.folderOpenIcon : this.folderIcon;
  }

  get folderIconCircle(): string {
    return this.opened ? 'minus' : 'plus';
  }

  get circleClass(): any {
    return {
      'selected': this.selected,
      'opened': this.opened,
      'closed': !this.opened
    }
  }
}